import { HARD_PATHS } from '../utils/hard-paths';

export const PATHS = {
    ABOUT: {
        path: `/about`,
    },
    PRESS_ROOM: {
        path: '/about/press-room',
    },
    NEWS: {
        path: '/about/news',
    },
    NEWS_PAGE: {
        path: '/about/news/:newsUrl',
    },
    CAREERS: {
        path: '/about/careers',
    },
    PARTNERS_PER_TYPE: {
        path: `/about/partners/:partnerType`,
    },
    PARTNERS: {
        path: `/about/partners`,
    },
    CONTACTS: {
        path: '/contact-audiokinetic',
    },
    BILIBILI: {
        hardPath: HARD_PATHS.FOOTER.BILIBILI,
    },
    FACEBOOK: {
        hardPath: HARD_PATHS.FOOTER.FACEBOOK,
    },
    BLUESKY: {
        hardPath: HARD_PATHS.FOOTER.BLUESKY,
    },
    NAVER: {
        hardPath: HARD_PATHS.FOOTER.NAVER,
    },
    TWITCH: {
        hardPath: HARD_PATHS.FOOTER.TWITCH,
    },
    TWITTER: {
        hardPath: HARD_PATHS.FOOTER.TWITTER,
    },
    LINKEDIN: {
        hardPath: HARD_PATHS.FOOTER.LINKEDIN,
    },
    WECHAT: {
        hardPath: HARD_PATHS.FOOTER.WECHAT,
    },
    WEIBO: {
        hardPath: HARD_PATHS.FOOTER.WEIBO,
    },
    YOUTUBE: {
        hardPath: HARD_PATHS.FOOTER.YOUTUBE,
    },
};
